"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsJsonValidator {
    isValid(input) {
        if (input) {
            return validatorJS.isJSON(input);
        }
        return false;
    }
}
exports.IsJsonValidator = IsJsonValidator;
//# sourceMappingURL=IsJsonValidator.js.map